module.exports = __webpack_public_path__ + "static/media/vf_wdress_core.c66eb11c.svg";